:host {
  display: block;
  @apply pb-8 pt-1
}
